<div class="sidenav-logo" fxLayout="row" fxLayoutAlign="center center">
  <app-logo />
</div>

<mat-nav-list class="menu-items-holder">
  <a mat-list-item routerLinkActive="selected" routerLink="dashboard">
    <div
      class="items-holder"
      fxLayout="row"
      fxLayoutAlign="space-between center"
    >
      <span>داشبورد</span>
      <jam-icon name="dashboard" />
    </div>
  </a>

  <a mat-list-item routerLinkActive="selected" routerLink="users">
    <div
      class="items-holder"
      fxLayout="row"
      fxLayoutAlign="space-between center"
    >
      <span>کاربران</span>
      <jam-icon name="users" />
    </div>
  </a>

  <a mat-list-item routerLinkActive="selected" routerLink="tasks">
    <div
      class="items-holder"
      fxLayout="row"
      fxLayoutAlign="space-between center"
    >
      <span>امتیازات</span>
      <jam-icon name="gift" />
    </div>
  </a>

  <a mat-list-item routerLinkActive="selected" routerLink="orders-history">
    <div
      class="items-holder"
      fxLayout="row"
      fxLayoutAlign="space-between center"
    >
      <span>سفارشات ویرایش پایان‌نامه</span>
      <jam-icon name="history" />
    </div>
  </a>
  <a mat-list-item routerLinkActive="selected" routerLink="carts">
    <div
      class="items-holder"
      fxLayout="row"
      fxLayoutAlign="space-between center"
    >
      <span>سبدهای خرید</span>
      <jam-icon name="shopping-cart" />
    </div>
  </a>
  <a mat-list-item routerLinkActive="selected" routerLink="cellar">
    <div
      fxLayout="row"
      class="items-holder"
      fxLayoutAlign="space-between center"
    >
      <span>انبار</span>
      <jam-icon color="accent" name="sitemap" />
    </div>
  </a>
  <a mat-list-item routerLinkActive="selected" routerLink="delivery-methods">
    <div
      fxLayout="row"
      class="items-holder"
      fxLayoutAlign="space-between center"
    >
      <span>روش‌های ارسال</span>
      <jam-icon color="accent" name="car" />
    </div>
  </a>
</mat-nav-list>
